import { Box, Grid, Modal, Typography } from '@mui/material'
import Water_Merlin from '../../../assets/devices/WaterMerlinNBOT.svg'
import Q600 from '../../../assets/devices/Q600.svg'
import { type AssetByIdState } from '../redux/assetByIdSlice'
import DeviceUtil from '../../../utils/DeviceUtil'
import DefaultImage from '../../../assets/devices/No-Image-Placeholder.svg'
import HBG3 from '../../../assets/devices/HBG3.svg'
import V200H from '../../../assets/devices/V200H.svg'
import React, { useEffect } from 'react'
import LanguageStrings from '../../../i18n/locales'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { type RootState } from '../../../store'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { fetchAssetData, fetchDeviceHistory } from '../redux/actionCreator'
import { type IPConfigState } from '../redux/ipConfigSlice'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import CloseIcon from '@mui/icons-material/Close'
import { type DeviceHistory } from '../services/deviceLifeCycleHistoryService'
import { type DeviceHistoryState } from '../redux/deviceLifeCycleHistorySlice'

const assetValuesStyles = {
  color: '#F0F0F0',
  fontWeight: '500'
}

const modalStyleState = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: '#272727',
  fontFamily: 'Honeywell Sans Web',
  p: 4,
  borderRadius: '5px'
}

const ParameterListComponentStrings = LanguageStrings().AssetConfigurationStrings.components.AssetDetailsComponents.ParameterListComponent

export function getDeviceImage (device: any): string {
  // istanbul ignore else
  if (device != null) {
    if (DeviceUtil.getDeviceTypeByName(device)?.isWater === true) {
      if (DeviceUtil.getDeviceTypeByName(device)?.isQ600 === true) {
        return Q600
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isHBG3 === true) {
        return HBG3
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isV200H === true) {
        return V200H
      }
      return Water_Merlin
    }
  }
  return DefaultImage
}

const AssetSummary = (props: AllProps): JSX.Element => {
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const [showHistoryDetailsModal, setshowHistoryDetailsModal] = React.useState(false)
  const auth = useAuth()
  React.useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
  }, [])

  const displayStateHistory = (): void => {
    setshowHistoryDetailsModal(true)
  }

  // istanbul ignore next
  const closedisplayStateHistory = (): void => {
    setshowHistoryDetailsModal(false)
  }

  useEffect(() => {
    props.fetchDeviceHistory(props.assetData.assetData?.id?.toString() ?? '', auth.user?.profile.customer as string)
  }, [])

  if (props.assetData.httpStatus === 401) {
    return (
      <div className="authError">
        <AuthError errorMessage="Unauthorized" />
      </div>
    )
  } else if (props.assetData.httpStatus === 403) {
    return (
      <div className="authError">
        <AuthError errorMessage="accessForbidden" />
      </div>
    )
  } else {
    return (
    <Grid container style={{ paddingTop: '20px' }}>
      <Grid xs={12} sm={2}>
        <div
          style={{
            padding: '10px',
            backgroundColor: 'white',
            height: 'fit-content',
            borderRadius: '10px',
            width: 'fit-content'
          }}
        >
          <img
            src={
              getDeviceImage(props.assetData.assetData?.device_type)
            }
            style={{ width: '100px', height: 'auto' }}
          />
        </div>
      </Grid>
      <Grid container xs={12} sm={10}>
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Asset_Type}</Grid>
            <Grid style={{ color: '#64C3FF' }}>
              {props.assetData.assetData?.device_type}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
          <Grid>{props.OverviewStrings.State} <span style={{ color: '#64C3FF', cursor: 'pointer' }} onClick={() => { displayStateHistory() }} data-testid= "view-history">(View History)</span></Grid>
            <Grid style={assetValuesStyles}>{props.assetData.assetData?.asset_state}</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Year_of_Certification}</Grid>
            <Grid>-----</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>Tag</Grid>
            <Grid>{props.assetData.assetData?.tag[0]?.name !== null && props.assetData.assetData?.tag[0]?.name !== undefined ? props.assetData.assetData?.tag[0]?.name : 'Not Available' } </Grid>
          </Grid>
        </Grid>
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Asset_Configuration}</Grid>
            <Grid style={{ color: '#64C3FF' }}>-----</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Serial_Number}</Grid>
            <Grid style={assetValuesStyles}>{props.assetData.assetData?.comm_mod_serial ?? ParameterListComponentStrings.Not_Applicable}</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Installation_Date}</Grid>
            <Grid>
              {props.assetData.assetData?.install_date !== null &&
              props.assetData.assetData?.install_date !== undefined
                ? new Date(
                  props.assetData.assetData?.install_date
                ).toDateString()
                : '----'}
            </Grid>
          </Grid>
        </Grid>
        <Grid container className='assetSummaryRow'>
        <Grid item xs={12} sm={3}>
            <Grid>Meter Serial Number</Grid>
            <Grid>
              {props.assetData.assetData?.serial_number}
            </Grid>
        </Grid>
        {((props.assetData.assetData?.device_type.startsWith('Water')) === true) && (
          <>
              <Grid item xs={12} sm={3}>
                  <Grid>Meter Date of Expiry</Grid>
                  <Grid>
                    -----
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid>Remaining Battery Percentage</Grid>
                  <Grid>
                  {((props.assetData.assetData?.rem_bat_percent) != null) ? props.assetData.assetData?.rem_bat_percent?.toString() : 'Not Available'}
                  </Grid>
                </Grid>
          </>
        )}
        </Grid>
        {((props.assetData.assetData?.device_type.startsWith('Water')) === true) && (
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid>Meter Date of Shipment</Grid>
            <Grid>
              -----
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>Firmware Version</Grid>
            <Grid>
              {props.assetData.assetData?.firmware_version !== null ? props.assetData.assetData?.firmware_version : 'Not Available'}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid>IP & Port</Grid>
                  <div style={{ display: 'flex', paddingTop: '10px', alignItems: 'center' }}>
                  <span style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                   { props.assetData.assetData?.ip_address !== null ? props.assetData.assetData?.ip_address : 'Not Available' } : { props.assetData.assetData?.port !== null ? props.assetData.assetData?.port : 'Not Available' }
                  </span>
                </div>
          </Grid>
          <div>
          <Modal className='Edit-AssetSummary-Modal deviceHistory-modal' open={showHistoryDetailsModal} onClose={() => { closedisplayStateHistory() }}>
        <Box sx={modalStyleState}>
        <div className='title' style={{ marginBottom: '30px' }}>
            <Typography id='modal-modal-title' variant='h6' component='h2'>
              State History
            </Typography>
            <CloseIcon data-testid='Close-Button-Model'
              style={{ cursor: 'pointer' }}
              onClick={() => { closedisplayStateHistory() }}
            />
          </div>
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <table className='stateHistory-table' style={{ width: '100%', padding: '10px 5px 0 0' }}>
            <tbody>
              <tr>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.FromState}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.ToState}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.StateCreateDate}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.StateEndDate}</th>
                <th style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{ParameterListComponentStrings.TransitionTime}</th>
              </tr>
              {
                props.deviceHistory.deviceHistory !== undefined
                  ? props.deviceHistory.deviceHistory.map((row: DeviceHistory, index: number) => (
                      <tr key={index}>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_from}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_to}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_create_date}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.state_end_date}</td>
                        <td style={{ margin: '1em 0 0 0', fontSize: '14px', height: '40px', border: '1px solid #737373' }}>{row.transition_time}</td>
                      </tr>
                  ))
                  : <></>
                }
            </tbody>
          </table>
        </div>
        </Box>
      </Modal>
          </div>
        </Grid>
        )}
        <Grid
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            paddingTop: '20px',
            paddingBottom: '20px'
          }}
          container
        >
        </Grid>
      </Grid>
    </Grid>
    )
  }
}

interface DispatchToProps {
  fetchAssetData: (id: string, tenantId: string) => void
  getOperationPermissions: (sub: string) => void
  fetchDeviceHistory: (assetId: string, tenantId: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchAssetData: (id: string, tenantId: string) => dispatch(fetchAssetData(id, tenantId)),
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  fetchDeviceHistory: (assetId: string, tenantId: string) => dispatch(fetchDeviceHistory(assetId, tenantId))
})

interface StateToProps {
  ipConfigState: IPConfigState
  assetId: string
  deviceHistory: DeviceHistoryState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  ipConfigState: state.ipConfigState,
  assetId: state.assetId,
  deviceHistory: state.deviceHistory
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface ParentProps {
  assetData: AssetByIdState
  OverviewStrings: any
}

type AllProps = PropsFromRedux & ParentProps

export default connector(AssetSummary)
